module.exports = __webpack_public_path__ + "assets/img/logo.b31b9de3.png";